<template>
	<div>
		<div style="margin:15px 0">
			<!-- 面包屑 -->
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/cardList' }">明信片管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type === 1 ? '隐私政策' : '用户协议' }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-card class="box-card">
			<editor v-model="protocol" :init="editorInit"/>
		</el-card>
		<div class="footer-btns">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="save">保 存</el-button>
		</div>
	</div>
</template>

<script>
import {request, postcardPutObject} from "../../axios/index";
import api from "../../api/card";
import Editor from '@tinymce/tinymce-vue';

export default {
	components: {Editor},
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			uploadPath: postcardPutObject,
			protocol: '',
			editorInit: {
				language: 'zh_CN',
				height: '680px',
				convert_urls: false,
				plugins: [
					'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr  imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount image'
				],
				toolbar: [
					'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
					'hr bullist numlist  charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen image'
				],
				images_upload_handler: function (blobInfo, success, failure) {
					const formData = new FormData()
					formData.append('file', blobInfo.blob());
					request({
						url: postcardPutObject,
						method: 'post',
						data: formData
					}).then(res => {
						success(res)
					}).catch(() => {
						failure('上传失败，请重新上传')
					})
				}
			},
			type: 1
		}
	},
	mounted() {
		let query = this.$route.query;
		this.type = query.type;
		this.protocol = this.$datas.protocol;
	},
	methods: {
		save() {//保存
			let data = {};
			if (this.type === 1) {
				data.user_private = this.protocol;
			} else data.user_agree = this.protocol;
			api.updateExpress(data).then(res => {
				this.cancel();
			}).catch(err => {
				this.$message({
					type: 'error',
					message: err.msg
				});
			})
		},
		cancel() {
			this.$router.push({
				path: "/cardList"
			});
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 120px;
	height: 120px;
	line-height: 120px;
	text-align: center;
}

.avatar {
	width: 120px;
	height: 120px;
	display: block;
}

.el-radio.is-bordered {
	padding-right: 10px;
}

.footer-btns {
	padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/card/protocol.vue